import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { LoanChecklistRuleResults } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface UpdateLoanChecklistRuleResultsParams {
  checklistRuleResultId: string; // The ID of the notification to mark as read
  requestBody: LoanChecklistRuleResults;
}

export interface UpdateLoanChecklistRuleResultsResponse {
  success: boolean;
}

const updateLoanChecklistRuleResults: MutationFunction<
  boolean,
  UpdateLoanChecklistRuleResultsParams
> = async (args) => {
  if (isMockServices()) return (await mock(_mockType)).success;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateLoanChecklistRuleResultsResponse>(
    `/loan-checklist-rule-results/${args.checklistRuleResultId}`,
    {
      method: 'PUT',
      body: {
        loanChecklistRuleId: args.requestBody.loanChecklistRuleId,
        rules: args.requestBody.rules,
      },
    },
  );
  if (response.data) return response.data.success;

  throw new Error('Failed to update notification status');
};

export default updateLoanChecklistRuleResults;

const _mockType = {
  success: true,
};
